/* eslint-disable i18next/no-literal-string */
import React from "react";

import {
  Avatar,
  Box,
  Card,
  Flex,
  Group,
  Text,
  Image,
  ThemeIcon,
} from "@mantine/core";

import { IconBookmark, IconCaretRightFilled } from "@tabler/icons-react";

interface TitleContentProps {
  copy?: string;
  iconURL: string | null;
  playerInitials: string;
}

export const TitleContent: React.FC<TitleContentProps> = (props) => {
  const { copy, iconURL, playerInitials } = props;

  return (
    <Group justify="space-between" mt="md">
      <Group gap="0.5em">
        {playerInitials ? (
          <Avatar color="cyan" radius="xl" size="sm">
            {playerInitials}
          </Avatar>
        ) : null}
        {iconURL ? <Image src={iconURL} h={24} w={24} /> : null}
        {copy ? <Text fw={500}>{copy}</Text> : null}
      </Group>

      <Box style={{ marginLeft: "auto" }}>
        <Group gap="0.5em">
          <Text size="sm" fw="600">
            2 days ago
          </Text>
          <ThemeIcon variant="transparent">
            <IconBookmark />
          </ThemeIcon>
        </Group>
      </Box>
    </Group>
  );
};

export const GoToArticleIcon: React.FC<{ isVisible: boolean }> = (props) => {
  return props.isVisible ? (
    <Card.Section px="sm">
      <Flex justify="flex-end">
        <ThemeIcon variant="filled" radius="xl">
          <IconCaretRightFilled />
        </ThemeIcon>
      </Flex>
    </Card.Section>
  ) : null;
};
